import { irTypesConst } from '../../integrationruntime/integrationruntime.constants';
import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { IntegrationRuntime } from './integrationRuntime';
import { Credential } from '../credential/credential';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: irTypesConst.SelfHosted
})
export class SelfHostedIntegrationRuntime extends IntegrationRuntime {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: shellStringResources.Credential,
        reference: true,
        type: Credential.MODEL
    })
    public credential?: Credential;

    public sharedIROriginalResourceId?: string;
    public version?: string;
    public subType?: string;
    public selfContainedInteractiveAuthoringEnabled?: boolean;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
